import React, { Component } from 'react';
import { Tabs } from 'antd';

import Crumbar from "../crumbstyle-navigator/Crumbar";

import PropertyGallery from "./PropertyGallery";
import PropertyGridShell from "./PropertyGridShell";

import { } from "./Editors/DoubleEditor";
import { } from "./Editors/NumberEditor";
import { } from "./Editors/SliderEditor";
import { } from "./Editors/StringEditor";
import { } from "./Editors/TextEditor";
import { } from "./Editors/EnumEditor";
import { } from "./Editors/BoolEditor";
import { } from "./Editors/FontEditor";
import { } from "./Editors/ImageEditor";
import { } from "./Editors/ColorEditor";
import { } from "./Editors/CssEditor";
import { } from "./Editors/ImageSetEditor";
import { } from "./Editors/JsonEditor";
// import ScriptServiceEditor from "./Editors/ScriptServiceEditor";
// import ScriptServiceSelector from "./Editors/ScriptServiceSelector";
import { } from "./Editors/FieldMapEditor";
import { } from "./Editors/DateTimeEditor"
import { } from "./Editors/DynamicQueryEditor";
import { } from "./Editors/ComboBoxEditor";
import { } from "./Editors/ColorSetEditor";
import { } from "./Editors/JsEditor";
import { } from "./Editors/ColorSetSelectEditor";
import { } from "./Editors/TableColumnsEditor";
import { } from "./Editors/ObjectEditor";
import { } from "./Editors/ObjectsEditor";
import { } from "./Editors/DataSourceSelectorEditor";
import { } from "./Editors/DataSourceAndMyDataSelectorEditor";
import { } from "./Editors/FileUrlEditor";
import { } from "./Editors/JsonObjectEditor";
import { } from "./Editors/ThicknessEditor";
import { } from "./Editors/PropertyGridEditor";
import { } from "./Editors/LengthEditor";
import { } from "./Editors/PercentRangeEditor";
import { } from "./Editors/LengthVerticalEditor";
import { } from "./Editors/LengthHorizontalEditor";
import { } from "./Editors/FontWeightEditor";
import { } from "./Editors/CssLengthEditor";
import { } from "./Editors/OffsetEditor";

// import TablePathEditor from './ToolboxEditors/TablePathEditor';

import { } from "./Editors/DiagramRefsEditor";
import { } from "./Editors/HtmlEditor";
import { } from "./Editors/OriginalImageEditor";

import 'freesia-ui/src/css/fonts.less';
import './Editors/editor.less';
import './PropertyGrid.less';

const { TabPane } = Tabs;

export default class PropertyGrid extends Component {

    resizeHandler = [];
    state = {

        activeTab: "primary",
        activeSource: null,
        subs: []
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.source === this.props.source)
            return;

        // this.state.subs.forEach(c => c.unregisterPropertyChangedListener());
        this.state.subs = [];
        this.setState({
            activeTab: "primary",
            activeSource: nextProps.source,
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.source !== this.props.source || nextState.activeTab !== this.state.activeTab;
    }

    registerResizeHandler(handler) {
        this.resizeHandler.push(handler);
        return () => {
            const i = this.resizeHandler.indexOf(handler);
            if (i >= 0)
                this.resizeHandler.splice(i, 1);
        }
    }

    resize(width, height) {
        this.width = width || this.width;
        this.height = height || this.height;
        this.resizeHandler.forEach(c => c(this.width, this.height));
    }

    append(property, obj) {

        const parentKey = this.state.subs.length ? (this.state.subs.length - 1) + "" : "primary";
        const parent = this.state.subs.length ? this.state.subs[this.state.subs.length - 1].source : this.props.source;

        // const unregisterPropertyChangedListener = obj.registerPropertyChangedListener((name, valOld, valNew, subName) => {
        //     // property.raisePropertyValueChanged(`value`, valOld, valNew);
        //     // parent.raisePropertyValueChanged(`${property.name}.${name}`, valOld, valNew, subName);
        // });

        const item = {
            property,
            source: obj,
            name: property.alias || property.name,
            title: property.alias || property.name,
            // icon: property.svg,
            // unregisterPropertyChangedListener,
            onClose: (bSetState = true) => {
                // unregisterPropertyChangedListener();
                this.state.subs.pop();
                if (bSetState) {
                    this.setState({
                        activeTab: parentKey,
                        activeSource: parent,
                    });
                }
            }
        };

        this.state.subs.push(item);
        this.setState({
            activeTab: (this.state.subs.length - 1) + "",
            activeSource: obj,
        });
    }

    navigateTo(c) {
        let index = this.state.subs.indexOf(c);
        for (let i = this.state.subs.length - 1; i > index; i--) {
            this.state.subs[i].onClose(i === index + 1);
        }
    }

    renderCrumbar() {
        return (
            <Crumbar className="propertygrid-crumbar"
                style={{ display: !this.state.subs.length ? "none" : "flex", padding: "0 10px 2px 10px", backgroundColor: 'transparent' }}
                arrowStyle={{ paddingTop: 0, opacity: 0.4, transform: "scale(0.8)" }}
                items={[...this.state.subs]}
                onNavigateTo={c => this.navigateTo(c)}
                rootTooltip={"返回到根级"}
                showRootText={false} >

            </Crumbar>
        );
    }

    render() {

        const formItemLayout = this.props.orient === "v" ? {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        } : {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 9 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 15 },
            },
        };


        return (
            <div className={"propertygrid-container fill layout-v vstretch vscroll " + (this.props.orient === "v" ? "orient-v " : "") + (this.props.className || "")}>
                {
                    this.renderCrumbar()
                }
                <Tabs className="fill" activeKey={this.state.activeTab} animated={false}>
                    <TabPane tab="primary" key="primary">
                        <PropertyGallery source={this.props.source} propertyGrid={this.props.propertyGrid || this} formItemLayout={this.props.formItemLayout || formItemLayout} showDescription={this.props.showDescription} orient={this.props.orient} />
                    </TabPane>
                    {
                        this.state.subs.map((c, i) => (
                            <TabPane tab={i} key={i}>
                                <PropertyGridShell onClose={() => c.onClose()} title={c.title}>
                                    <PropertyGallery source={c.source} propertyGrid={this.props.propertyGrid || this} formItemLayout={this.props.formItemLayout || formItemLayout} showDescription={this.props.showDescription} orient={this.props.orient} />
                                </PropertyGridShell>
                            </TabPane>
                        ))
                    }
                </Tabs>
            </div>
        );
    }
}